import { useState } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal, Pencil, Trash2, Merge } from "lucide-react";
import { Trip } from "@/hooks/useTrips";
import { EditTripDialog } from "./EditTripDialog";
import { DeleteTripDialog } from "./DeleteTripDialog";
import { MergeTripsDialog } from "./MergeTripsDialog";

interface TripActionsMenuProps {
  trip: Trip;
  allTrips: Trip[];
}

export function TripActionsMenu({ trip, allTrips }: TripActionsMenuProps) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [mergeOpen, setMergeOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8">
            <MoreHorizontal className="h-4 w-4" />
            <span className="sr-only">Trip actions</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setEditOpen(true)}>
            <Pencil className="h-4 w-4 mr-2" />
            Edit Trip
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setMergeOpen(true)} disabled={allTrips.length < 2}>
            <Merge className="h-4 w-4 mr-2" />
            Merge Trips
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem 
            onClick={() => setDeleteOpen(true)}
            className="text-destructive focus:text-destructive"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Delete Trip
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <EditTripDialog trip={trip} open={editOpen} onOpenChange={setEditOpen} />
      <DeleteTripDialog trip={trip} open={deleteOpen} onOpenChange={setDeleteOpen} />
      <MergeTripsDialog targetTrip={trip} allTrips={allTrips} open={mergeOpen} onOpenChange={setMergeOpen} />
    </>
  );
}